import React from 'react';
import { Modal, Tabs } from 'antd';
import EditAssignmentServicesOrderForm from '../Forms/EditAssignmentServicesOrderForm.js';
import EditAssignmentDetailsForm from '../Forms/EditAssignmentDetailsForm.js';

const { TabPane } = Tabs;

const EditAssignmentContainer = ({ state, user, ...props }) => {

  return(
    <Modal
      open={state.showItemContextModal}
      title={props.contextMenuSelection}
      onCancel={props.handleModalCancel}
      footer={[
      ]}
    >
     {
       (
          !state.loading &&
            <Tabs defaultActiveKey="1">
              <TabPane tab={<p>Services Order</p>} key="1">
                <EditAssignmentServicesOrderForm
                  loading={state.loading}
                  tableDataSource={state.tableDataSource}
                  job={state.job} // actually pulling from parent state
                  jobElement={state.jobElement}
                  jobElementsWithDetails={state.jobElementsWithDetails}
                  costObject={state.costObject}
                  updatingUser={state.updatingUser}
                  resource={state.resource}
                  itemDetails={state.itemDetails}
                  user={user}
                  groupsByBranchInCompany={state.groupsByBranchInCompany}
                  service={state.service}
                  assignmentServicesByGroup={state.assignmentServicesByGroup}
                  servicesByGroup={state.servicesByGroup}
                  activityTypes={state.activityTypes}
                  serviceSalaryLevel={state.serviceSalaryLevel}
                  servicePrimaryRate={state.servicePrimaryRate}
                  serviceJobSalaries={state.serviceJobSalaries}
                  confirmDialogue={state.confirmDialogue} // not currently used...
                  updateState={props.updateState}
                  generateItemDuration={props.generateItemDuration}
                  handleItemDurationChange={props.handleItemDurationChange}
                  handleItemStartTimeChange={props.handleItemStartTimeChange}
                  handleItemEndTimeChange={props.handleItemEndTimeChange}
                  handleOmnibusFieldChange={props.handleOmnibusFieldChange}
                  getJobElement={props.getJobElement}
                  getGroupsByBranchInCompany={props.getGroupsByBranchInCompany}
                  getService={props.getService}
                  getAssignmentServicesByGroup={props.getAssignmentServicesByGroup}
                  getServicesByGroup={props.getServicesByGroup}
                  getActivityTypes={props.getActivityTypes}
                  getServiceSalaryLevel={props.getServiceSalaryLevel}
                  getServicePrimaryRate={props.getServicePrimaryRate}
                  getJobSalariesByService={props.getJobSalariesByService}
                  updateAssignment={props.updateAssignment}
                />
              </TabPane>
              <TabPane tab={<p>Details</p>} key="2">
                <EditAssignmentDetailsForm
                    loading={state.loading}
                    job={state.job}
                    costObject={state.costObject}
                    updatingUser={state.updatingUser}
                    resource={state.resource}
                    itemDetails={state.itemDetails}
                    user={user}
                    approvedJobElements={state.approvedJobElements}
                    confirmDialogue={state.confirmDialogue} // not currently used...
                    updateState={props.updateState}
                    // handleItemDurationChange={props.handleItemDurationChange}
                    handleItemStartTimeChange={props.handleItemStartTimeChange}
                    // handleItemEndTimeChange={props.handleItemEndTimeChange}
                    handleOmnibusFieldChange={props.handleOmnibusFieldChange}
                    // getGroupsByBranchInCompany={props.getGroupsByBranchInCompany}
                    // getService={props.getService}
                    // getAssignmentServicesByGroup={props.getAssignmentServicesByGroup}
                    // getActivityTypes={props.getActivityTypes}
                    // getServiceSalaryLevel={props.getServiceSalaryLevel}
                    // getServicePrimaryRate={props.getServicePrimaryRate}
                    // getJobSalariesByService={props.getJobSalariesByService}
                    // updateAssignment={props.updateAssignment}

                    getApprovedJobElements={props.getApprovedJobElements}
                    getJobElements={props.getJobElements}
                    handleItemDelete={props.handleItemDelete}
                    updateJob={props.updateJob}


                  />
              </TabPane>

          </Tabs>
       )
       ||
       'loading...'
    }

    </Modal>
  )

}

export default EditAssignmentContainer;
